var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2222_1723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6861 0H1.31387C0.588239 0 0 0.588239 0 1.31387C0 2.0395 0.588239 2.62774 1.31387 2.62774H18.6861C19.4118 2.62774 20 2.0395 20 1.31387C20 0.588239 19.4118 0 18.6861 0Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.376 5.40149H4.224C3.548 5.40149 3 5.98973 3 6.71536C3 7.44099 3.548 8.02923 4.224 8.02923H15.376C16.052 8.02923 16.6 7.44099 16.6 6.71536C16.6 5.98973 16.052 5.40149 15.376 5.40149Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9854 10.8151H7.31387C6.58824 10.8151 6 11.4033 6 12.1289C6 12.8546 6.58824 13.4428 7.31387 13.4428H11.9854C12.711 13.4428 13.2993 12.8546 13.2993 12.1289C13.2993 11.4033 12.711 10.8151 11.9854 10.8151Z",
    fill: "#C1C1C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2222_1723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 13.4307,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.a10d4e8ae254c6a3b9da4d32e3dcbdff.svg";
export { ForwardRef as ReactComponent };